import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputCustomField } from './InputCustomField.entity';

export class InputRaZahlung<T extends EMode = EMode.entity> {
  /** Alias: code */
  code?: number;
  /** Alias: benutzerCode */
  benutzerCode?: number;
  /** Alias: buchungsDatum */
  buchungsDatum?: string;
  /** Alias: datev */
  datev?: string;
  /** Alias: datum */
  datum?: string;
  /** Alias: konto */
  konto?: string;
  /** Alias: notiz */
  notiz?: string;
  /** Alias: sachkontoCode */
  sachkontoCode?: number;
  /** Alias: sachkonto */
  sachkonto?: number;
  /** Alias: summe */
  summe?: number;
  /** Alias: raCode */
  raCode?: number;
  /** Alias: customFields */
  customFields?: InputCustomField<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<InputRaZahlung> = {
  code: {
    alias: 'code',
  },
  benutzerCode: {
    alias: 'benutzerCode',
  },
  buchungsDatum: {
    alias: 'buchungsDatum',
  },
  datev: {
    alias: 'datev',
  },
  datum: {
    alias: 'datum',
  },
  konto: {
    alias: 'konto',
  },
  notiz: {
    alias: 'notiz',
  },
  sachkontoCode: {
    alias: 'sachkontoCode',
  },
  sachkonto: {
    alias: 'sachkonto',
  },
  summe: {
    alias: 'summe',
  },
  raCode: {
    alias: 'raCode',
  },
  customFields: {
    alias: 'customFields',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputRaZahlungEntityDefinition: EntitiyDefinition<InputRaZahlung> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputRaZahlung',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
